import { isEmpty } from 'lodash';

export const GBAddressMapper = (storeAddress) => {
  if (storeAddress?.CountryCode !== 'GB') {
    return {
      line1: '',
      line2: '',
      line3: '',
      postCode: '',
    };
  }

  if (isEmpty(storeAddress?.AddressFields)) {
    return {
      line1: '',
      line2: storeAddress?.Line1 || '',
      line3: storeAddress?.City || '',
      postCode: storeAddress?.Postcode || '',
    };
  }

  return storeAddress.AddressFields;
};
